export enum CourseStatus {
  INIT = 'INIT',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSE',
  FINISHED = 'FINISHED',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CourseStatus {
  export function getDisplayText(status: CourseStatus): string {
    switch (status) {
      case CourseStatus.INIT:
        return 'אותחל';
      case CourseStatus.ACTIVE:
        return 'פעיל';

      case CourseStatus.FINISHED:
        return 'הסתיים';

      case CourseStatus.CLOSED:
        return 'סגור';
      default:
        return '';
    }
  }

  export function parseCourseStatus(status: string): CourseStatus {
    return (
      CourseStatus[status as keyof typeof CourseStatus] ?? CourseStatus.INIT
    ); // Default to INIT if not found
  }
}
